<template>
    <div class="animated fadeIn container-fluid page-content">
        <SectionTitle :title="'Liên hệ và góp ý'" />
        <b-row :align-h="'center'">
            <b-col xl="4" lg="6" md="8">
                <b-card border-variant="light" class="card-doc">
                    <b-form-group label="Tên">
                        <b-form-input v-model="form.name" placeholder="Nhập thông tin" />
                    </b-form-group>
                    <b-form-group label="Email">
                        <b-form-input v-model="form.email" type="email" placeholder="Nhập thông tin" />
                    </b-form-group>
                    <b-form-group label="Số điện thoại">
                        <b-form-input v-model="form.phone" type="number" placeholder="Nhập thông tin" />
                    </b-form-group>
                    <b-form-group label="Địa chỉ">
                        <b-form-input v-model="form.address" placeholder="Nhập thông tin" />
                    </b-form-group>
                    <b-form-group label="Nội dung góp ý">
                        <b-form-textarea rows="5" v-model="form.content" placeholder="Nhập thông tin" />
                    </b-form-group>

                    <div class="text-center">
                        <b-button type="submit" :disabled="!isEnableForm" @click="onSubmit" variant="primary">
                            <i class="fa fa-paper-plane mr-2" />
                            Gửi</b-button>
                    </div>
                </b-card></b-col>
        </b-row>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle';
import { mapActions } from 'vuex';
export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            form: {}
        };
    },
    computed: {
        isEnableForm() {
            return (
                this.form.name &&
                this.form.phone &&
                this.form.email &&
                this.form.address &&
                this.form.content
            );
        }
    },
    methods: {
        ...mapActions({
            updateOrCreate: 'feedback/updateOrCreate'
        }),
        async onSubmit() {
            await this.updateOrCreate(this.form);
            this.$toaster.success('Góp ý của bạn đã gửi thành công');
            this.form = {};
        }
    }
};
</script>
<style lang="scss" scoped></style>
